/**
 * Inline head script that aligns the document theme class with the user's
 * preference before first paint.
 *
 * SSR reads the `en_theme` cookie. The client also mirrors the choice into
 * localStorage for instant toggles. When those diverge (refresh before the
 * theme-switch response lands, or a stale cookie), the page used to paint the
 * cookie theme then flip — typically dark → light. This script heals that
 * before the body paints.
 */
export const THEME_COOKIE_NAME = "en_theme";
export const THEME_STORAGE_KEY = "theme";
export const DEFAULT_THEME = "light" as const;

export function getThemeBootstrapScript(): string {
  // Keep this self-contained: no imports, runs before React/hydration.
  return `(function(){
  var cookieName=${JSON.stringify(THEME_COOKIE_NAME)};
  var storageKey=${JSON.stringify(THEME_STORAGE_KEY)};
  var fallback=${JSON.stringify(DEFAULT_THEME)};
  var syncFlag='theme-cookie-sync';
  function readCookie(){
    var m=document.cookie.match(/(?:^|; )en_theme=([^;]*)/);
    return m?decodeURIComponent(m[1]):null;
  }
  function writeCookie(value){
    document.cookie=cookieName+'='+encodeURIComponent(value)+'; path=/; max-age=31536000; SameSite=Lax';
  }
  function apply(theme){
    var root=document.documentElement;
    root.classList.remove('light','dark');
    root.classList.add(theme);
  }
  var cookieTheme=readCookie();
  var stored=null;
  try{stored=localStorage.getItem(storageKey);}catch(e){}
  var cookieOk=cookieTheme==='light'||cookieTheme==='dark';
  var storedOk=stored==='light'||stored==='dark';
  if(storedOk&&stored!==cookieTheme){
    try{
      if(!sessionStorage.getItem(syncFlag)){
        sessionStorage.setItem(syncFlag,'1');
        writeCookie(stored);
        window.location.reload();
        return;
      }
    }catch(e){}
  }
  try{sessionStorage.removeItem(syncFlag);}catch(e){}
  var systemTheme=window.matchMedia&&window.matchMedia('(prefers-color-scheme: dark)').matches?'dark':fallback;
  var theme=cookieOk?cookieTheme:storedOk?stored:systemTheme;
  if(cookieOk&&!storedOk){
    try{localStorage.setItem(storageKey,cookieTheme);}catch(e){}
  }
  apply(theme);
})();`;
}
